import React from "react";
import Button from "../Button/Button";
import "./1vs1.css";
import Modal from "react-bootstrap/Modal";
import { useState, useEffect } from "react";
import { GamePopupContext } from "../Context/GamePopupContext";
import { useContext } from "react";
import { FindGame } from "../../GameServices/GameServices";
import { ExistingGames } from "./ExistingBets";
import { motion } from "framer-motion";
import { LazyMotion, domAnimation } from "framer-motion";

function CustomBetPopUp(props) {
  const { dispatchPopUp, gameState } = useContext(GamePopupContext);
  const [Amount, setAmount] = useState(null);
  const [Existing, setExisting] = useState([]);
  const [ButtonValue, setButtonValue] = useState("Create Bet");
  const [Images, setImages] = useState(props.gameImage.stages);

  const handleGameClick = (id) => {
    let a = props.gameImage.stages.map((element, e) => {
      if (id === e) {
        return { ...element, isActive: true };
      } else {
        return { ...element, isActive: false };
      }
    });
    setImages(a);
  };
  useEffect(() => {
    setImages(props.gameImage.stages);
  }, [props.gameImage.stages]);

  useEffect(() => {
    return () => {
      setExisting([]);
      setButtonValue("Create Bet");
      setImages(props.gameImage.stages);
    };
  }, []);

  async function handleClick() {
    if (Images.some((e) => e.isActive === true)) {
      let data = {
        id: Images.findIndex((object) => {
          return object.isActive === true;
        }),
        game: props.gameImage.name,
      };
      data.type = props.gameImage.stages
        ? props.gameImage.stages[data.id].stage
        : 1;
      data.value = parseInt(Amount);
      let response = await FindGame(
        {
          gameName: props.gameImage.name,
          betAmount: /* Amount */ 1,
          player_id:
            localStorage.getItem("user_id") ||
            "0x8fC73D9D27a730d4826E41babF76ee2D25f4736A",
          stage: props.gameImage.stages
            ? props.gameImage.stages[data.id].stage
            : 1,
        },
        true
      );
      if (response.data.gameId === -2 && response.data.challenges.length > 0) {
        setExisting(response.data.challenges);
        setButtonValue("Proceed With New Bet");
      } else {
        props.betHandler(data);
      }
    } else {
      alert("Select any Stage");
      return;
    }
  }
  async function handleClickProceed() {
    if (Images.some((e) => e.isActive === true)) {
      let data = {
        id: Images.findIndex((object) => {
          return object.isActive === true;
        }),
        value: /* Amount */ 1,
        game: props.gameImage.name,
      };
      data.type = props.gameImage.stages
        ? props.gameImage.stages[data.id].stage
        : 1;

      props.betHandler(data);
    } else {
      alert("Select any Stage");
      return;
    }
  }
  const handlePopupClose = () => {
    console.log("close");
    setExisting([]);
    setButtonValue("Create Bet");
    setImages(props.gameImage.stages);
    dispatchPopUp({ type: "close" });
  };

  return (
    <LazyMotion features={domAnimation}>
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Modal
          show={gameState.showCustomBet}
          onHide={() => handlePopupClose()}
          className="gamescreen-modal"
        >
          <div className="section-onevsone custom-bet">
            <div className="container">
              <div className="row matic-row">
                <div className="col-lg-6">
                  <div className="matic-info">
                    <div className="matic-image">
                      <img src={require("./images/matic.png")} alt="matic" />
                    </div>
                    <div className="matic-text">
                      <h3>11,250</h3>
                      <p>Matic Available</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 cancel-image">
                  <img
                    src={require("./images/cancel-error-popup.png")}
                    onClick={() => handlePopupClose()}
                    alt="popup"
                  />
                </div>
              </div>
              <div className="row head-row">
                <div className="col-lg-12">
                  <h1>Select A Board</h1>
                </div>
              </div>
              <motion.div
                className="row board-row"
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
              >
                {Images?.map((ele, id) => {
                  return (
                    <div className={`col-lg-3 gameStage${id}`} key={id}>
                      <img
                        className={ele.isActive === true ? `image-active` : ``}
                        src={ele.img}
                        onClick={() => {
                          handleGameClick(id);
                        }}
                        alt="img-active"
                      />
                    </div>
                  );
                })}
              </motion.div>
              <div className="row head-row">
                <div className="col-lg-12">
                  <h1>{props.betAmount}</h1>
                </div>
                <div className="col-lg-12">
                  <div className="form-us ">
                    <input
                      onChange={(e) => setAmount(e.target.value)}
                      type="number"
                      className="form-control matic-amount"
                      placeholder="Enter your Amount"
                    />
                    <div className="col-lg-2 matic-img">
                      <img src={require("./images/matic.png")} alt="matic" />
                    </div>
                  </div>
                  {Existing?.length > 0 ? (
                    <ExistingGames challenges={Existing} />
                  ) : (
                    ""
                  )}
                  <div className="col-lg-12">
                    <Button
                      value={ButtonValue}
                      onClick={() => {
                        Existing.length > 0
                          ? handleClickProceed()
                          : handleClick();
                      }}
                      disabled={Amount !== null && Amount !== "" ? false : true}
                      className = {Images?.some((e) => e?.isActive === true) && Amount !== null && Amount !== "" ? "" : "grey"}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </motion.div>
    </LazyMotion>
  );
}
export default CustomBetPopUp;
